<template>
  <div class="p-refine" :style="{ zIndex: shown ? 999 : 1 }">
    <div class="p-refine__header" @click.stop>
      <button
        ref="button"
        v-touch:tap
        type="button"
        class="p-refine__heading"
        @click="switchShownState"
      >
        <slot name="body">
          <ButtonRefineBase :width="width">
            <span v-if="heading && rangeEnable">{{ sortedHeading }}</span>
            <span v-else>{{ heading }}</span>
            <template v-if="icon" #icon>
              <IconBase
                :width="iconSize"
                :height="iconSize"
                :view-box="iconViewBox"
                :icon-color="iconColor"
              >
                <component :is="iconComponent" />
              </IconBase>
            </template>
          </ButtonRefineBase>
        </slot>
      </button>
    </div>
    <transition name="fade">
      <div
        v-if="refineItemList"
        v-show="shown"
        class="p-refine__list c-common-rounded-shadow"
        :style="listStyle"
      >
        <slot name="items">
          <ul>
            <li
              v-for="({ value, label }, key) in refineItemList"
              :key="key"
              class="p-refine__list__item"
            >
              <input
                :id="value"
                v-model="internalRefine"
                type="radio"
                class="p-refine__input"
                :value="value"
              />
              <label
                v-touch:tap
                :for="value"
                class="p-refine__label c-common-rounded-shadow__label"
                >{{ label }}</label
              >
            </li>
          </ul>
        </slot>
      </div>
    </transition>

    <ModalMain v-if="modalName == 'dateSortModal'">
      <template #head>期間指定</template>
      <template #body>
        <div class="p-form-button-group">
          <div class="modal-second-heading">期間</div>

          <div class="modal-secont-middle">
            <InputDate
              :min-date="sortBeteenMinDate"
              :init-value="publishDate"
              name="sortBetweenMinDate"
              placeholder="日付選択"
              :range-enable="true"
              @input="inputDate"
            />

            <span class="sort-modal-between-sign">~</span>

            <InputDate
              :min-date="sortBeteenMinDate"
              :init-value="publishDate"
              name="sortBetweenMaxDate"
              placeholder="日付選択"
              :range-enable="true"
              @input="inputDate"
            />
          </div>

          <div class="p-form-button-group__buttons-main">
            <div class="p-form-button-group__vertical">
              <ButtonMain kind="cancel" @click-button="closeModal"
                >キャンセル</ButtonMain
              >
            </div>
            <div class="p-form-button-group__vertical">
              <ButtonMain type="button" kind="aside" @click-button="betweenSort"
                >決定する</ButtonMain
              >
            </div>
          </div>
        </div>
      </template>
    </ModalMain>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import dayjs from "dayjs";

import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSorted from "@/common/components/icons/IconSorted.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import InputDate from "@/common/components/atoms/InputDate.vue";

import modalState from "@/common/store/modules/modalState";

@Options({
  props: {
    heading: { type: [String, Boolean], default: "絞り込み" },
    icon: { type: [String, Boolean], default: false },
    iconColor: { type: String, default: "#000000" },
    refineItemList: { type: [Array, Boolean], default: false, required: true },
    refine: { type: [String, Number], default: "" },
    rangeEnable: { type: Boolean, default: false },
    shown: { type: Boolean, default: false },
    width: { type: String, default: "130px", required: false }
  },
  components: {
    ButtonRefineBase,
    IconBase,
    IconSorted,
    IconArrowBottom,
    ModalMain,
    ButtonMain,
    InputDate
  },
  computed: {
    modalName() {
      return modalState.modalName;
    }
  },
  watch: {
    sortedHeading(newVal: string, oldVal: string) {
      this.sortedHeading = newVal;
    },
    closeModalState() {
      this.switchState = false;
      this.$emit("switch-refine-state", false);
    }
  }
})
export default class ButtonRefine extends Vue {
  heading!: string;
  icon!: string;
  iconColor!: string;
  refineItemList!: boolean;
  refine!: string;
  rangeEnable!: boolean;
  shown!: boolean;
  width!: string;

  switchState = this.shown;
  listStyle: object = {};

  sortedHeading: any = "";
  sortModal = false;
  sortedDates: any = "";
  sortBetweenMinDate: any = "";
  sortBetweenMaxDate: any = "";

  get sortBeteenMinDate() {
    return new Date(1900, 11, 1);
  }

  get sortBeteenMaxDate() {
    return new Date();
  }

  updateSortDate(inputDate: { name: string; value: string }) {
    if (inputDate.name === "sortBetweenMinDate") {
      this.sortBetweenMinDate = dayjs(inputDate.value).format("YYYY-MM-DD");
    } else {
      this.sortBetweenMaxDate = dayjs(inputDate.value).format("YYYY-MM-DD");
    }
  }

  get internalRefine(): any {
    return this.refine;
  }

  set internalRefine(newValue: any) {
    this.sortedHeading = newValue;
    if (this.refine !== newValue) {
      if (newValue != "specify_period") {
        if (newValue == "all") {
          this.sortedHeading = "すべての期間";
        }
        this.$emit("update:refine", newValue);
        this.$emit("do-sort", newValue);
        this.switchShownState();
      } else if (newValue == "specify_period") {
        if (this.rangeEnable) {
          modalState.changeModal("dateSortModal");
          sessionStorage.removeItem("whatsNewMonth");
          sessionStorage.removeItem("whatsNewYear");
        }
        this.sortedHeading = "期間指定";
      }
      sessionStorage.sortedHeading = this.sortedHeading;
    }
  }

  setSortDate(date: any) {
    if (date != "all" && date != "specify_period") {
      this.$emit("do-sort", date);
      date = date.split(".");
      this.sortedHeading = date[0] + "年" + date[1];
    } else if (date == "all") {
      this.$emit("do-sort", date);
      this.sortedHeading = "すべての期間";
    } else {
      this.sortedHeading = "期間指定";
      modalState.changeModal("dateSortModal");
      sessionStorage.removeItem("whatsNewMonth");
      sessionStorage.removeItem("whatsNewYear");
    }

    sessionStorage.sortedHeading = this.sortedHeading;
  }

  betweenSort() {
    if (this.sortBetweenMinDate != "" && this.sortBetweenMaxDate != "") {
      const betweenSortDates = {
        startDate: this.sortBetweenMinDate,
        endDate: this.sortBetweenMaxDate
      };
      this.sortedHeading =
        "期間指定(" +
        this.sortBetweenMinDate.replaceAll("-", "/") +
        "--" +
        this.sortBetweenMaxDate.replaceAll("-", "/") +
        ")";
      sessionStorage.sortedHeading = this.sortedHeading;
      this.$emit("betweenSort", betweenSortDates);
    }

    this.closeModal();
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  mounted() {
    this.initSelectContentListStyle();
  }

  switchShownState() {
    const shownState = this.shown;
    const changeState = !shownState;
    this.$emit("switch-refine-state", changeState);
  }

  initSelectContentListStyle() {
    const button = this.$refs;
    const buttonHeight: any = button.clientHeight;
    this.listStyle = {
      top: `${buttonHeight / 16}rem`,
      width: `${this.width}`
    };
  }

  closeModal() {
    modalState.changeModal("");
    const switchState = !this.shown;
    this.$emit("switch-refine-state", switchState);
  }

  get iconComponent() {
    if (!this.icon) {
      return "IconSorted";
    }

    switch (this.icon) {
      case "sorted":
        return "IconSorted";
      case "arrow":
        return "IconArrowBottom";
      default:
        return "IconSorted";
    }
  }

  get iconViewBox() {
    return this.icon === "sorted" ? "0 0 16 16" : "0 0 24 24";
  }

  get iconSize() {
    return this.icon === "sorted" ? 16 : 24;
  }

  async created() {
    this.switchState = this.shown;
    if (this.rangeEnable) {
      if (sessionStorage.sortedHeading) {
        this.sortedHeading = sessionStorage.sortedHeading;
      } else {
        this.sortedHeading = this.heading;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.p-refine {
  position: relative;

  &__header {
    position: relative;
  }

  &__heading {
    position: relative;
    display: block;
    width: 100%;

    &.tap {
      cursor: pointer;
    }
  }

  &__list {
    position: absolute;
    width: 130px;
    display: block;
    left: 0;
    z-index: 1;

    &__item {
      width: 100%;
      position: relative;
    }
  }

  &__input {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    left: 0;
    top: 0;
    opacity: 0;
  }

  &__label {
    font-size: rem(12);
    text-align: center;
    display: block;
    padding: rem(10) rem(8);
    position: relative;
  }
}
</style>

<style>
.p-refine .p-modal-main__content {
  padding: 1.5rem 0 !important;
  width: 30rem !important;
  height: 21rem !important;
}

.p-refine .p-modal-main__head {
  font-size: 1.2rem;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 1.5rem;
}

.p-refine .p-modal-main__body {
  padding: 1.5rem;
  margin-top: 0 !important;
}

.p-refine .p-form-button-group {
  margin-top: 0 !important;
}

.p-refine .modal-second-heading {
  margin-bottom: 1.5rem;
  font-weight: bold;
  text-transform: capitalize;
}

.p-refine .modal-secont-middle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p-refine .sort-modal-between-sign {
  font-size: 1.5rem;
  font-weight: bold;
}

.p-refine .p-form-button-group__vertical {
  width: 48% !important;
  height: 65px !important;
  font-size: 18px !important;
}

.p-refine .p-form-button-group__buttons-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}

.p-refine .p-form-button-group__vertical + .p-form-button-group__vertical {
  margin-top: 0 !important;
}

.p-refine .c-input-date__wrap {
  height: 75px !important;
}

.p-refine .c-input-date.c-input-date--has_icon {
  height: 100% !important;
  font-size: 19px;
}

.p-refine .p-button-main--cancel {
  border: unset !important;
}

.p-refine .p-button-main--aside {
  background: #ee1c25 !important;
}
</style>
